import { SubscriptionProductsTab } from './subscriptions-products-tab'
import { SubscriptionPurchasesTab } from './subscriptions-purchases-tab'
import { SubscriptionProductOverviewTab } from './subscriptions-product-overview-tab'
import { SubscriptionProductSubscribersTab } from './subscriptions-product-subscribers-tab'
import { SubscriptionProductContentTab } from './subscriptions-product-content-tab'
import { SubscriptionPurchaseOverviewTab } from './subscriptions-purchase-overview-tab'
import { SubscriptionPurchaseContentTab } from './subscriptions-purchase-content-tab'
export { SubscriptionUserPurchasesTab } from './subscriptions-user-purchases-tab'

export const subscriptionTabs = [SubscriptionProductsTab, SubscriptionPurchasesTab]

export const subscriptionProductDetailTabs = [
  SubscriptionProductOverviewTab,
  SubscriptionProductSubscribersTab,
  SubscriptionProductContentTab,
]

export const subscriptionPurchaseDetailTabs = [
  SubscriptionPurchaseOverviewTab,
  SubscriptionPurchaseContentTab,
]
